<template>
  <q-bar class="bg-white">
    <q-btn dense flat round :to="{ name: 'AccountPersonalInfo' }">
      <i class="fas fa-chevron-left"></i>
    </q-btn>
    <div class="col text-center">{{ $t('account.editPersonalInfo') }}</div>
  </q-bar>

  <div class="q-ma-md">
    <q-form ref="form">
      <q-input
        v-model="form.name"
        outlined
        type="text"
        bg-color="white"
        :label="`${$t('personalInfo.name')} *`"
        :rules="nameRules"
      />

      <q-tel-input v-model="phone" :rules="phoneRules" @input="onInput" />

      <q-btn
        class="full-width q-mt-md"
        color="primary"
        :label="$t('generic.text.submit')"
        @click="onSubmit"
      />
    </q-form>
  </div>
</template>

<script>
import QTelInput from '@/components/QTelInput.vue';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    QTelInput,
  },
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        name: '',
        phone: '',
      },
      phone: '',
      firstNameRules: [
        (v) =>
          !!v ||
          this.$t('generic.error.required', {
            msg: this.$t('register.firstName'),
          }),
      ],
      lastNameRules: [
        (v) =>
          !!v ||
          this.$t('generic.error.required', {
            msg: this.$t('register.lastName'),
          }),
      ],
      nameRules: [
        (v) =>
          !!v ||
          this.$t('generic.error.required', {
            msg: this.$t('register.name'),
          }),
      ],
      phoneRules: [
        (v) =>
          !!v ||
          this.$t('generic.error.required', { msg: this.$t('register.phone') }),
      ],
    };
  },
  computed: {
    ...mapState({
      personalInfo: (state) => state.user.personalInfo,
    }),
  },
  created() {
    this.phone = this.form.phone = this.personalInfo.pmsPhone;
    this.form.name = this.personalInfo.name;
  },
  methods: {
    ...mapActions({
      editPersonalInfo: 'user/editPersonalInfo',
    }),

    onInput(val) {
      let code = val.phoneObject.countryCallingCode;
      let number = val.phoneObject.nationalNumber;
      if (code && number) {
        let _phone = `+${code} ${number}`;

        this.phone = _phone;
        this.form.phone = _phone;
      }
    },
    onSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success) return;

        this.editPersonalInfo(this.form)
          .then(() => {
            this.$notify.create({
              type: 'positive',
              position: 'top',
              message: this.$t('account.editPersonalInfo.success'),
            });
          })
          .catch((err) => {
            console.log(err);

            this.$notify.create({
              type: 'negative',
              position: 'top',
              message: this.$t('account.editPersonalInfo.failed'),
              caption: err.response.data,
            });
          });
      });
    },
  },
};
</script>
